import React, {useEffect, useState} from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import Select from 'react-select';
import { resourcesGeofence } from '../../../helpers/backend_helper';
import { getStorageUser } from '../../../helpers/api_helper';
import Validate from './Validate'

const AddGeoModal = ({newGeo,setNewGeo,setItem,item,items, setItems, setEdit}) => {
	const [ errors, setErrors ] = useState([]);
	const [ geofences, setGeofences ] = useState([]);
	const [ loading, setLoading ] = useState(false);
	const authUser = getStorageUser();
	const handleClose = () => {
		setNewGeo({...newGeo,show:false,update:false});
	}
	const [filters,setFilters] = useState({tipo: 'geocerca', page:1,perPage:20,search:'',orderBy:'id',order:'asc',companySession:authUser.company_id,select:true});
	let params={params:filters}

	const handlerOnChange = (value,name) => {
		console.log(name, value, item)
		// La zona del ramal arranca con la zona de la geocerca; se puede cambiar en la tabla
		setItem({...item, ['geofence']:value,['geofence_id']:value.id,['geofence_name']:value.name,['zone_id']:value.zone_id ?? null,['id']:items.length});
	}

	const save = () => {
		setEdit(true)
    	let newItem = {...item};
    	let array = [];
    	if(newGeo.update){
    		array = items.map((item, index) => index == newGeo.idx ? newItem : item);
    	}else{
			newItem.position = items.length
    		array = [...items, newItem];
    		array.sort((a, b) => {
    			return a.position - b.position;
    		});
    	}
    	setItems(array);
    	handleClose()
    }

	useEffect(() => {
		const getGeodence =  async() => {
			const response = await resourcesGeofence('get',params)
    		setGeofences(response.data)	
		}
		getGeodence()
    }, [])
    return (
		<div>
	        <Modal isOpen={newGeo.show}>
				<ModalHeader className="bg-primary">
					{newGeo.update ? 'Editar ':'Agregar '}Geocerca
				</ModalHeader>
				<ModalBody>
					<div className="row">
						<div className="col-sm-12">
						    <label className="form-label">Geocerca:</label>
						    <Select
								className="basic-single"
								classNamePrefix="select"
								isClearable={true}
								defaultValue={item.geofence}
								isSearchable={true}
								getOptionLabel={(option) => `${option.name}`}
								getOptionValue={(option) => `${option.id}`}
								name="color"
								options={geofences}
								onChange={ e => handlerOnChange(e, 'geofence_id') }
							/>
						    {
						    	errors && <div className="form-text text-danger">{errors.geofence_id && errors.geofence_id[0]}</div>
						    }
						</div>
					</div>	
				</ModalBody>
				<ModalFooter>
					<Button color="primary" onClick={save} disabled={loading}>
						{loading && <Spinner size="sm"></Spinner> } <i className='fa fa-plus'></i> Agregar
					</Button>{' '}
					<Button color="secondary" onClick={handleClose}><i className='fa fa-times'></i> Cancelar</Button>
				</ModalFooter>
	        </Modal>
		</div>
	);
}

export default AddGeoModal;